import React, { useMemo } from 'react';
import { comprobarOrtografiaTexto } from '../../utils/spanishSpellChecker';

export default function InputDescripcionConOrtografia({
  value = '',
  onChange,
  placeholder = 'Ej: Mantenimiento general',
  disabled = false,
  className = '',
  style = {},
  ariaLabel = 'Descripción',
  ...props
}) {
  const { faltas, textoSugerido } = useMemo(() => comprobarOrtografiaTexto(value), [value]);

  const aplicarCorrecion = (nuevoTexto) => {
    if (onChange && nuevoTexto) {
      onChange(nuevoTexto);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
      <div style={{ position: 'relative', width: '100%' }}>
        <input
          {...props}
          type="text"
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          spellCheck="true"
          lang="es"
          aria-label={ariaLabel}
          className={className}
          style={{
            width: '100%',
            borderColor: value && value.trim() && faltas.length > 0 ? '#f59e0b' : undefined,
            paddingRight: value && value.trim() && faltas.length > 0 ? 32 : undefined,
            ...style,
          }}
        />
        {value && value.trim() && faltas.length > 0 && (
          <span
            title={`Posibles faltas ortográficas: ${faltas.map((f) => `${f.palabra} → ${f.sugerencia}`).join(', ')}`}
            style={{
              position: 'absolute',
              right: 10,
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: 13,
              pointerEvents: 'none',
              lineHeight: 1,
            }}
          >
            ⚠️
          </span>
        )}
      </div>

      {value && value.trim() && faltas.length > 0 && (
        <div
          style={{
            fontSize: 11,
            color: '#b45309',
            background: '#fffbeb',
            border: '1px solid #fde68a',
            borderRadius: 6,
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            flexWrap: 'wrap',
          }}
        >
          <span>⚠️ Posible falta ortográfica:</span>
          {faltas.map((f, idx) => (
            <span key={idx} style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
              <span style={{ textDecoration: 'line-through', opacity: 0.75 }}>{f.palabra}</span> →{' '}
              <strong style={{ color: '#92400e' }}>{f.sugerencia}</strong>
            </span>
          ))}
          {textoSugerido && (
            <button
              type="button"
              onClick={() => aplicarCorrecion(textoSugerido)}
              style={{
                marginLeft: 'auto',
                background: '#fef3c7',
                border: '1px solid #fcd34d',
                borderRadius: 4,
                padding: '2px 8px',
                fontSize: 11,
                cursor: 'pointer',
                fontWeight: 600,
                color: '#78350f',
              }}
            >
              Corregir
            </button>
          )}
        </div>
      )}
    </div>
  );
}
